import BaseService from "../core/base-service";
import StorageService, { StorageItems } from "../core/storage-service";

export default class PatentnewsService extends BaseService {
  // TODO: change this to your route in server
  static route = "patentnews";
  private storage: StorageService = new StorageService();

  /*专利列表接口*/
  async getPatentnewsData(pageNo = 1, title?: string, area?: string) {
    const url = `/api/news/patent`;
    const formData = {
      page: pageNo,
      size: 3,
    };

    const response = await this.httpService.post<any, any>(url, formData);
    return response;
  }
}